import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
// Services
import { DynamicTableService } from '../../_services/dynamic-table.service';
import { DocumentsService } from '../../_services/documents.service';
// Model
import { DocumentTableColumn } from '../../_models/document';

const defaultPageNumber : number = 10;

@Component({
  standalone: false,
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.scss']
})
export class DynamicTableComponent implements OnInit, OnChanges {
  constructor(
    private tableService: DynamicTableService,
    private documentsService: DocumentsService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.tableData && !changes.tableData.firstChange) {
      this.tableData = changes.tableData.currentValue;
      this.renderedData = JSON.parse(JSON.stringify(changes.tableData.currentValue));

      if (this.renderedData && this.renderedData.length) {
        this.renderedData.forEach(doc => {
          let newConfig = {};
          for (let key of Object.keys(doc)) {
            newConfig[key] = false;
          }
          this.fullTextConfig[doc['id']] = newConfig;
        });
      }
      this.renderedData = this.tableService.updateTableWithTextFilters(this.textFilters, this.tableData || []);
      this.renderedData = this.tableService.searchByText(this.searchedText, this.renderedData, this.textFilters, this.tableData);
    }
  }

  // Inputs updatable

  p: number = 1;
  private _searchedText: string;

  @Input() set searchedText(value: string) {
    this._searchedText = value;
    this.tableData = this.documentsService.getDocumentsValue();
    this.renderedData = this.tableService.searchByText(this._searchedText, this.renderedData, this.textFilters, this.tableData);

    this.selectAll = this.dynamicSelectAll(this.renderedData);

  }
  @Input() hideSelection: boolean = false;

  get searchedText(): string {
    return this._searchedText;
  }

  private _textFilters: Array<string> = [];

  @Input() set textFilters(value: Array<string>) {
    this._textFilters = value;
    // filter renderedData    
    this.tableData = this.documentsService.getDocumentsValue();
    this.renderedData = this.tableService.updateTableWithTextFilters(this._textFilters, this.tableData || []);

    this.selectAll = this.dynamicSelectAll(this.renderedData);
  }

  get textFilters(): Array<string> {
    return this._textFilters;
  }

  // Required Inputs
  @Input() columnNames: DocumentTableColumn[];
  @Input() tableData: Array<object>;
  // Optional Inputs
  @Input() enableSorting: boolean = true;
  // Local Variables
  selectAll: boolean = false;
  renderedData: Array<object>;
  fullTextConfig: Object = {};
  ngOnInit(): void {

    this.renderedData = JSON.parse(JSON.stringify(this.tableData));
    if (this.renderedData && this.renderedData.length) {
      this.renderedData.forEach(doc => {
        let newConfig = {};
        for (let key of Object.keys(doc)) {
          newConfig[key] = false;
        }
        this.fullTextConfig[doc['id']] = newConfig;
      });
    }
    this.renderedData = this.tableService.updateTableWithTextFilters(this.textFilters, this.tableData || []);
  }

  private dynamicSelectAll(data) {
    if (data && data.length) {
      const checkedDocs = JSON.parse(JSON.stringify(data)).filter(d => d.checked);
      return checkedDocs.length == data.length;
    }
    return false;
  }

  public getPageLength() {
    const currentUser = JSON.parse(localStorage.getItem('user'));

    if (currentUser?.selectedLocationIndex != null && currentUser?.locationRoles != null) 
    {
      const { PageLength } = currentUser.locationRoles[currentUser.selectedLocationIndex];
      return PageLength;
    }
    return defaultPageNumber;
  }

  // Sorting columns
  public sort(col) {
    // Stop execution if the column is not sorteable
    if (!col.sortable) {
      return;
    }
    // Local variables
    let direction = this.tableService.changeDirection(col.sort);
    let columnData = col;
    columnData.sort = direction;

    // Resetting other headers
    this.tableData = this.documentsService.getDocumentsValue();
    this.renderedData = this.tableService.resetHeaders(this.renderedData, this.tableData);
    this.renderedData = this.tableService.updateTableWithTextFilters(this.textFilters, this.tableData || []);
    this.renderedData = this.tableService.searchByText(this.searchedText, this.renderedData, this.textFilters, this.tableData);

    // Stop execution if the direction is not defined
    if (direction === '') {
      return;
    }

    // Sorting data
    this.tableService.sortColumns(direction, this.renderedData, columnData);
    // Resetting columns previous sort
    this.columnNames = this.tableService.resetColumnSort(columnData);

  }

  // Mark document as selected
  public selectDocument(rowValue) {
    const documents = this.documentsService.getDocumentsValue().map((d, i) => {
      /// por nominado
      if (d.id === rowValue.id || d['checked'] && rowValue.Nominated) {
        const mod = { ...d, checked: !d['checked'] };
        const idx = this.renderedData.findIndex(rd => rd['id'] === d.id);
        this.renderedData[idx] = mod;
        return mod;
      }
      return d;
    });

    this.documentsService.initDocuments(documents);

    let localTableData = this.documentsService.getDocumentsValue();
    let localRenderedData = this.tableService.updateTableWithTextFilters(this.textFilters, localTableData || []);
    localRenderedData = this.tableService.searchByText(this.searchedText, localRenderedData, this.textFilters, localTableData);

    this.selectAll = this.dynamicSelectAll(localRenderedData);
  }

  public showText(document, column) {
    const { name } = column;
    const { id } = document;
    this.fullTextConfig[id][name] = !this.fullTextConfig[id][name];
  }

  public checkAll() {
    this.selectAll = !this.selectAll;
    /// por nominado
    this.renderedData = this.renderedData.map(r => { return { ...r, checked: this.selectAll && !r['Nominated'] } });
    const documents = this.documentsService.getDocumentsValue().map(d => {
      const renderedElement = this.renderedData.find(r => r['Id'] === d.Id);
      if (renderedElement) {
        return { ...d, checked: renderedElement['checked'] }
      }
      return d;
    });
    this.documentsService.initDocuments(documents);
  }

  public parseRowValue(rowValue, colName) {
    let renderedValue = colName.name === 'Tally' ? parseInt(rowValue[colName.name], 10).toString() : rowValue[colName.name];
    if (renderedValue == '0') return '';
    if (this.shouldHideFullText(colName, rowValue)) {
      return renderedValue.substring(0, colName.maxLength);
    } else {
      return renderedValue ? renderedValue.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1") : renderedValue;
    }
  }

  public shouldHideFullText(colName, rowValue) {
    let renderedValue = colName.name === 'Tally' ? parseInt(rowValue[colName.name], 10).toString() : rowValue[colName.name];

    return renderedValue && (renderedValue.length > colName.maxLength) && !this.fullTextConfig[rowValue.id][colName.name];
  }


}
